import React, { useContext } from "react";
import { useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import MailIcon from "@mui/icons-material/Mail";
import { SiteContext } from "gatsby-frontend/src/Site";
import { SingleContext } from "gatsby-frontend/src/Page";

function Share({ buttons, color, shareLocation }) {
	const theme = useTheme();
	const { twitterUsername } = useContext(SiteContext);
	const { slug, title, summary, attributes } = useContext(SingleContext);
	const url = `${process.env.GATSBY_SITE_URL}${slug}`;
	const tweet = `${url} ${title} ${
		twitterUsername ? "by @" + twitterUsername : ""
	} `;

	const customSummaryField = theme?.customOptions?.customSummaryField;
	const customSummary = attributes[customSummaryField];

	const emailBody = encodeURIComponent(
		customSummaryField && customSummary ? customSummary : summary
	);

	const email = `mailto:?subject=${encodeURIComponent(
		title
	)}&body=${emailBody}${encodeURIComponent(" \n\n ")}${encodeURIComponent(
		url
	)}`;

	return (
		<Stack
			className="share-buttons"
			direction={shareLocation === "side" ? "column" : "row"}
			spacing={1}
			sx={{
				margin: 0,
				marginTop: theme.spacing(-1),
				"& a": {
					color: `${color} !important`,
					"&:after": { display: "none !important" },
				},
			}}
		>
			{buttons.includes("facebook") && (
				<IconButton
					aria-label="Share on Facebook"
					component="a"
					href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
						url
					)}`}
					target="_blank"
					sx={{ marginLeft: `0 !important` }}
				>
					<FacebookIcon sx={{ color: color }} />
				</IconButton>
			)}
			{buttons.includes("twitter") && (
				<IconButton
					aria-label="Share on Twitter (X)"
					component="a"
					href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
						tweet
					)}`}
					target="_blank"
					sx={{ marginLeft: `0 !important` }}
				>
					<svg 
						xmlns="http://www.w3.org/2000/svg"
						height="0.9em"
						viewBox="0 0 512 512"
						style={{ fill: color }}
					>
						<path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
					</svg>
				</IconButton>
			)}
			{buttons.includes("linkedin") && (
				<IconButton
					aria-label="Share on LinkedIn"
					component="a"
					href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
						url
					)}`}
					target="_blank"
					sx={{ marginLeft: `0 !important` }}
				>
					<LinkedInIcon sx={{ color: color }} />
				</IconButton>
			)}
			{buttons.includes("email") && (
				<IconButton
					aria-label="Share by Email"
					component="a"
					href={email}
					target="_blank"
					sx={{ marginLeft: `0 !important` }}
				>
					<MailIcon sx={{ color: color }} />
				</IconButton>
			)}
		</Stack>
	);
}

export default Share;
